(function ($) {
	const faqItem = $('.schema-faq-section');
	faqItem.on('click', function (event) {
		event.preventDefault();

		const answer = $(this).children('.schema-faq-answer');
		answer.slideToggle('fast');
		answer.parent(faqItem).toggleClass('open');
		answer.parent(faqItem).hasClass('has-not-bottom-borders')
			? setTimeout(function () { answer.parent(faqItem).removeClass('has-not-bottom-borders'); }, 200)
			: answer.parent(faqItem).addClass('has-not-bottom-borders');
	});
}(jQuery));